import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppButton() {
    const phoneNumber = "5541992362095";
    const message = "Olá! Vim pelo site e gostaria de atendimento.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        // mostra tooltip após 2 segundos
        const timer = setTimeout(() => {
            setShowTooltip(true);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    const handleClick = () => {
        const isFbqAvailable = typeof window.fbq !== 'undefined';

        if (isFbqAvailable) {
            console.log(`Rastreando evento ClickBotaoWhatsApp no Facebook Pixel`);
            window.fbq('trackCustom', 'ClickBotaoWhatsApp', {
                numberOfClicks: 1
            });
        }
        setShowTooltip(false);
    }

    return (
        <>
            <style>
                {`
                    @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.08); }
                    100% { transform: scale(1); }
                    }

                    @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(10px); }
                    to { opacity: 1; transform: translateY(0); }
                    }
                `}
            </style>

            <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 9999 }}>

                {showTooltip && (
                    <div
                        style={{
                            position: "absolute",
                            bottom: "70px",
                            right: "0",
                            background: "#fff",
                            color: "#333",
                            padding: "10px 14px",
                            borderRadius: "10px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                            fontSize: "14px",
                            whiteSpace: "nowrap",
                            animation: "fadeIn 0.3s ease",
                        }}
                    >
                        💬 Fale com a gente no WhatsApp!
                    </div>
                )}
                <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => handleClick()}
                    style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                        backgroundColor: "#25D366",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        boxShadow: "0 6px 18px rgba(0,0,0,0.3)",
                        animation: "pulse 1.8s infinite",
                        textDecoration: "none",
                    }}
                >
                    <FaWhatsapp size={28} />
                </a>
            </div>
        </>
    );
}